export const environment = {
  production: true,
  // apiUrl: 'https://m.brandnewegg.com:8081/v1/api/'
  apiUrl: 'https://m.brandnewegg.com:8081/v2/'
};
